<template>
	<div id="cs-login">
		<cs-loading-logo />
	</div>
</template>
<script type="text/javascript">
/**
 * * Login page component
 * 	*
 * 	* @version 1.0.0
 * 	* @since 1.0.0
 *
 * @format
 */

export default {
	name: 'cs-login',

	components: {
		'cs-loading-logo': () => import(/* webpackChunkName: "../global/cs-loadinglogo" */ '../global/cs-loadinglogo')
	},

	props: {
		/**
		 * The user object, required for varioius personalised functions
		 */
		user: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			loginLoader: ''
		};
	},

	mounted() {
		this.initLogin(); //this is instead of the emit in cs-loading-logo
	},

	beforeDestroy() {
		clearTimeout(this.redirectTimeout);
	},

	methods: {
		/**
		 * @public
		 * @description
		 * Initialises the login process once the loader is in place
		 */
		initLogin() {
			if (Object.keys(this.user).length === 0) {
				if (this.$route.query.redirect) {
					localStorage.setItem('redirectAfterLogin', this.$route.query.redirect);
				}

				this.redirectTimeout = setTimeout(() => {
					this.$auth.getUserManager().signinRedirect();
				}, 1400);
			} else {
				this.$router.push({name: 'home', params: {entityorscreen: 'home'}});
			}
		}
	}
};
</script>
<style lang="scss">
/** @format */

#cs-login {
	position: fixed;
	display: flex;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: radial-gradient(circle at 50% 0, #565e6c, #2b303a) no-repeat center;

	.cs-loading-logo {
		width: 100%;
		height: 100%;

		&::after {
			display: none;
		}
	}
}
</style>
